import { AccountBox } from "@mui/icons-material";
import React from "react";

import { SubNavBar } from "components/common/SubNavBar";
import { Typography } from "new-components/typography/Typography";
import { User } from "types/users";

interface AccountSubHeaderProps {
  user: User | undefined;
}

export function AccountSubHeader(props: AccountSubHeaderProps) {
  const { user } = props;

  return (
    <SubNavBar>
      <AccountBox data-testid="AccountBoxIcon" className="text-3xl text-white text-opacity-50" />
      <Typography>{user?.username}&apos;s Account</Typography>
    </SubNavBar>
  );
}
